import "./styles.less";

import { Avatar, Button, Card, Col, Row, Space } from "antd";
import { FC, useState, useContext, useEffect } from "react";

import { ModalPhone } from "../../ModalPhone/web";
import Text from "antd/lib/typography/Text";
import { usePhoneButton } from "../../InformationRequest/LeadButtons/PhoneButton/hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { UserStateContext } from "shared-components/Contexts/User/context";
import dynamic from "next/dynamic";
import Mandatory from "shared-components/Components/User/Mandatory/web";
import { useUser } from "shared-components/Components/User/User.hook";
const Modal = dynamic(() => import("shared-components/Components/Modal/web").then(mod => mod.Modal), { ssr: false });

interface OwnerProps {
	property_id: string;
	name: string;
	maskedPhone: string;
	mode: string;
	logo?: string;
	disabled?: boolean;
	isProject?: boolean
}

export const Owner: FC<OwnerProps> = ({
	property_id,
	name,
	maskedPhone,
	mode,
	logo = null,
	disabled = false,
	isProject = false
}) => {
	const [modal, setModal] = useState(false);
	const { country_code } = useContext(ConfigStateContext);

	const { viewPhone, phone, loading } = usePhoneButton({ property_id, isProject });

	const handleClick = (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		if (!phone) {
			viewPhone().then(data => {
				if (data) setModal(true);
			});
		} else {
			setModal(true);
		}
	};
	const { isLoggedIn, user: { refetch } } = useUser();
	const [userHasAllData, setUserHasAllData] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const user = useContext(UserStateContext);

	useEffect(() => {
		if (country_code !== "CO") {
			setUserHasAllData(true);
		}
		if (country_code === "CO" && user.me) {
			const hasAllData = !!user.me.phone && !!user.me.name;
			setUserHasAllData(hasAllData);
		}
	}, [user.me]);

	return (
		<>
			<Modal
				show={isModalVisible}
				onClose={() => setIsModalVisible(false)}
				height="500px"
			>
				<div className="auth-modal-wrapper">
					<div className="auth-modal">
						<Mandatory
							onOk={(e: any) => {
								handleClick(e);
								setIsModalVisible(false);
								setUserHasAllData(true);
								refetch();
							}}
							user={user}
						/>
					</div>
				</div>
			</Modal>

			<Card size="small" className="owner">
				<Row gutter={16} align="middle">
					<Col>
						<Avatar alt={name}>{name[0]?.toUpperCase()}</Avatar>
					</Col>
					<Col
						flex={1}
						className="left"
						style={{ overflow: "hidden", position: "relative" }}>
						<Text>{name}</Text>
					</Col>
					<Col>
						{country_code !== "BR" && (
							<Space size={4}>
								<Text className="masked">{maskedPhone}</Text>
								{maskedPhone && (
									<Button
										loading={loading}
										onClick={(e: any) => {
											if (userHasAllData || !isLoggedIn) {
												handleClick(e)
											} else {
												setIsModalVisible(true);
											}
										}}
										className="secondary"
										disabled={disabled}>
										{"Ver teléfono"}
									</Button>
								)}
							</Space>
						)}
					</Col>
				</Row>
			</Card>
			<ModalPhone
				mode={mode}
				phone={phone}
				owner_name={name}
				property_id={property_id}
				loading={loading}
				visible={modal}
				onCancel={() => setModal(false)}
			/>
		</>
	);
};
